import { EBlockEventSingleChangeType } from '@components/block-event-single/constant/constant';
import { getDefaultBlockEventRuleItem } from '@components/block-event-single/utils/initializeUtils';
import { IBlockEventData } from '@src/common/types/empTypes';

export const deleteAllBlockRule = (data: IBlockEventData[], orIndex: number) => {
  data[orIndex].event_name = undefined;
  data[orIndex].block_rules = [];
  return data;
};

export const deleteBlockRuleItem = (
  data: IBlockEventData[],
  orIndex: number,
  subAndIndex: number,
  subOrIndex: number,
) => {
  data[orIndex].block_rules = data[orIndex]?.block_rules
    .map((subAndRules, subAndRulesIndex) => {
      if (subAndRulesIndex === subAndIndex) {
        const subAndRule = subAndRules.filter((subOrRule, subOrRuleIndex) => {
          return subOrRuleIndex !== subOrIndex;
        });
        if (subAndRule.length !== 0) {
          return subAndRule;
        }
      } else {
        return subAndRules;
      }
    })
    .filter(Boolean);
  if (data[orIndex].block_rules.length === 0) {
    data[orIndex].block_rules = [[getDefaultBlockEventRuleItem()]];
  }
  return data;
};

export const addOrBlockRuleItem = (data: IBlockEventData[], orIndex: number) => {
  const l = data[orIndex]?.block_rules.length;
  data[orIndex]?.block_rules[l - 1].push(getDefaultBlockEventRuleItem());
  return data;
};

export const updateBlockRules = (
  data: IBlockEventData[],
  orIndex: number,
  subAndIndex: number | null,
  subOrIndex: number | null,
  changeType: EBlockEventSingleChangeType,
  value: string,
) => {
  const blockEventSingleData = data[orIndex];
  let blockRuleItem;
  if (typeof subAndIndex === 'number' && typeof subOrIndex === 'number') {
    blockRuleItem = blockEventSingleData.block_rules[subAndIndex][subOrIndex];
  }
  switch (changeType) {
    case EBlockEventSingleChangeType.BLOCK_EVENT_SINGLE_NAME:
      blockEventSingleData.event_name = value;
      break;
    case EBlockEventSingleChangeType.BLOCK_EVENT_SINGLE_OPERATOR:
      if (blockRuleItem) blockRuleItem.op = value;
      break;
    case EBlockEventSingleChangeType.BLOCK_EVENT_SINGLE_VALUE:
      if (blockRuleItem) blockRuleItem.value = [value];
      break;
    default:
      break;
  }
  return data;
};
